/**
 * Created by Allan on 2022/03/03.
 * Contact 84880528@qq.com.
 * 墨西哥在线还款H5页面
 */

import Vue from 'vue'
import App from './App'
import store from '@/baseloan/store/'
import router from '@/baseloan/router/'
import Vant from 'vant'
import 'vant/lib/index.css'
import '@/baseloan/filters/'
import Http from '@/baseloan/service/http/'


Vue.use(Vant);
Vue.prototype.$http = Http;
Vue.config.productionTip = false

router.afterEach((to,from,next) => {
    window.scrollTo(0,0);
});

new Vue({
    el: '#app',
    store,
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/baseloan/main.js